/** KPI badges for portfolio PDF — must match Insights Overview cards (8 items). */
export function buildInsightsKpiItems(kpis = {}) {
  return [
    { label: "Total companies", value: kpis.totalOrgs ?? "—" },
    { label: "Participants invited", value: kpis.participantsInvited ?? "—" },
    { label: "Full assessments completed", value: kpis.participantsCompleted ?? "—" },
    { label: "Lite assessments completed", value: kpis.participantsLiteCompleted ?? "—" },
    {
      label: "Avg completion %",
      value: kpis.avgCompletion != null ? `${kpis.avgCompletion}%` : "—",
    },
    {
      label: "Avg overall score",
      value: kpis.avgOverall != null ? kpis.avgOverall : "—",
    },
    { label: "Active assessments", value: kpis.activeAssessments ?? "—" },
    { label: "Report-ready companies", value: kpis.reportReadyCount ?? "—" },
  ];
}
